type Props = {
  color?: string;
};

export default function RemoveFieldIcon({
  color = "var(--brand-primary-color)",
}: Props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill={color} fillOpacity="0.1" />
      <path d="M7.54999 7.54999L17.45 17.45" stroke={color} strokeWidth="2" />
      <path d="M17.45 7.54999L7.55001 17.45" stroke={color} strokeWidth="2" />
    </svg>
  );
}
